export default {
  latestUserAddons: (state) => state.latestUserAddons,
  latestAdminAddons: (state) => state.latestAdminAddons,
  foldersWithAddons: (state) => state.foldersWithAddons,
  leads: (state) => state.leads,
  isLoading: (state) => state.isLoading
};
